/**
 * City names for navigation chrome — slug, English name, Tamil name.
 *
 * ── Why this exists separately from `cityLanding.ts` ──────────────────────
 * `MarketingShell` is a client component, and the footer needs to link every
 * city page. Importing `CITY_LANDINGS` there would pull the entire landing
 * corpus — market prose, local points, FAQ answers for five cities — into the
 * client bundle to render five anchor tags. This module carries only the three
 * fields the chrome actually uses.
 *
 * The duplication is deliberate and is guarded: `scripts/route-drift.mjs`
 * fails the build if these slugs ever diverge from `CITY_LANDINGS`. Adding a
 * city means editing both files, and forgetting the second one breaks CI
 * rather than silently shipping a city page nothing links to.
 */
export interface CityNavEntry {
  slug: string;
  city: string;
  cityTa: string;
}

export const CITY_NAV: CityNavEntry[] = [
  {
    slug: 'chennai',
    city: 'Chennai',
    cityTa: 'சென்னை',
  },
  {
    slug: 'coimbatore',
    city: 'Coimbatore',
    cityTa: 'கோயம்புத்தூர்',
  },
  {
    slug: 'madurai',
    city: 'Madurai',
    cityTa: 'மதுரை',
  },
  {
    slug: 'tiruchirappalli',
    city: 'Tiruchirappalli',
    cityTa: 'திருச்சிராப்பள்ளி',
  },
  {
    slug: 'salem',
    city: 'Salem',
    cityTa: 'சேலம்',
  },
];
